/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_Remote_DescInputs */

const tr_landing_community_tile_remote_desc = /** @type {(inputs: Landing_Community_Tile_Remote_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekranınıza bağlanıp sorunu birlikte çözeriz. Benzer platformlarda bu genelde ek ücretlidir.`)
};

const en_landing_community_tile_remote_desc = /** @type {(inputs: Landing_Community_Tile_Remote_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We connect to your screen and fix the issue together. On comparable platforms this usually costs extra.`)
};

const de_landing_community_tile_remote_desc = /** @type {(inputs: Landing_Community_Tile_Remote_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir schalten uns auf Ihren Bildschirm und lösen das Problem gemeinsam. Bei vergleichbaren Anbietern kostet das in der Regel extra.`)
};

const ru_landing_community_tile_remote_desc = /** @type {(inputs: Landing_Community_Tile_Remote_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключаемся к вашему экрану и решаем проблему вместе. На сопоставимых платформах это обычно платно.`)
};

/**
* | output |
* | --- |
* | "We connect to your screen and fix the issue together. On comparable platforms this usually costs extra." |
*
* @param {Landing_Community_Tile_Remote_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_remote_desc = /** @type {((inputs?: Landing_Community_Tile_Remote_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_Remote_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_remote_desc(inputs)
	if (locale === "de") return de_landing_community_tile_remote_desc(inputs)
	if (locale === "ru") return ru_landing_community_tile_remote_desc(inputs)
	return tr_landing_community_tile_remote_desc(inputs)
});